<template>
  <div class="cs-wrap">
    <div v-if="!isIdiaContext" class="cs-guard">
      <strong>Bu sayfa sadece Altında Fırsat / Idia için kullanılabilir.</strong>
      <p>Üst menüden tenant <code>Altında Fırsat</code> ve marketplace <code>Idia</code> seçili olmalı.</p>
    </div>

    <template v-else>
      <header class="cs-header">
        <h1>Kargo Maliyet Mutabakatı</h1>
        <p class="cs-sub">Tamamlanmış siparişlerin kargo masraflarını listeler. Ödenmiş kargoları işaretleyerek YK faturası ile mutabakat tutarsın.</p>
      </header>

      <section class="cs-filters">
        <div class="cs-filter">
          <label>Başlangıç</label>
          <input v-model="filters.from" type="date">
        </div>
        <div class="cs-filter">
          <label>Bitiş</label>
          <input v-model="filters.to" type="date">
        </div>
        <div class="cs-filter">
          <label>Ödeme Durumu</label>
          <select v-model="filters.paymentStatus">
            <option value="all">Tümü</option>
            <option value="unpaid">Ödenmemiş</option>
            <option value="paid">Ödenmiş</option>
            <option value="partial">Kısmen Ödenmiş</option>
          </select>
        </div>
        <div class="cs-filter">
          <button class="cs-btn primary" :disabled="loading" @click="load(1)">{{ loading ? '...' : 'Filtrele' }}</button>
        </div>
        <div class="cs-filter">
          <button class="cs-btn ghost" :disabled="loading" @click="setThisMonth">📅 Bu Ay</button>
        </div>
      </section>

      <section class="cs-summary">
        <div class="cs-card cs-card-total">
          <div class="cs-card-label">Toplam</div>
          <div class="cs-card-value">{{ formatMoney(summary.totalAmount) }}</div>
          <div class="cs-card-sub">{{ summary.totalCount }} sipariş</div>
        </div>
        <div class="cs-card cs-card-paid">
          <div class="cs-card-label">Ödenmiş</div>
          <div class="cs-card-value">{{ formatMoney(summary.paidAmount) }}</div>
        </div>
        <div class="cs-card cs-card-unpaid">
          <div class="cs-card-label">Ödenmemiş</div>
          <div class="cs-card-value">{{ formatMoney(summary.unpaidAmount) }}</div>
        </div>
      </section>

      <section class="cs-table-wrap">
        <table class="cs-table">
          <thead>
            <tr>
              <th class="cs-col-check">
                <input type="checkbox" :checked="allChecked" :indeterminate.prop="someChecked" @change="toggleAll">
              </th>
              <th>Sipariş</th>
              <th>Mevcut Barkod</th>
              <th>Alıcı</th>
              <th>Şehir</th>
              <th>Tamamlanma</th>
              <th>Sevkiyat</th>
              <th class="cs-right">Toplam</th>
              <th class="cs-right">Ödenmiş</th>
              <th class="cs-right">Kalan</th>
              <th>Durum</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0 && !loading">
              <td colspan="11" class="cs-empty">Bu filtreyle eşleşen kayıt bulunamadı.</td>
            </tr>
            <template v-for="row in items">
              <tr :key="row.orderId" :class="['cs-row', expanded[row.orderId] ? 'cs-row-expanded' : '']">
                <td class="cs-col-check">
                  <input type="checkbox" v-model="selectedIds" :value="row.orderId">
                </td>
                <td>#{{ row.orderId }}</td>
                <td class="mono">{{ row.currentBarcode || '—' }}</td>
                <td>{{ row.recipientName || '—' }}</td>
                <td>{{ row.city || '—' }}</td>
                <td>{{ formatDate(row.completedDate) }}</td>
                <td>
                  <span class="cs-shipment-count">{{ row.shipmentCount }} kez</span>
                  <button class="cs-btn-tiny ghost" @click="toggleExpand(row.orderId)">{{ expanded[row.orderId] ? 'Gizle' : 'Detay' }}</button>
                </td>
                <td class="cs-right">{{ formatMoney(row.totalCost) }}</td>
                <td class="cs-right cs-paid-amount">{{ formatMoney(row.paidCost) }}</td>
                <td class="cs-right cs-unpaid-amount">{{ formatMoney(row.unpaidCost) }}</td>
                <td>
                  <span :class="['cs-badge', 'cs-badge-' + row.paymentStatus]">{{ statusLabel(row.paymentStatus) }}</span>
                </td>
              </tr>
              <tr v-if="expanded[row.orderId]" :key="row.orderId + '-d'" class="cs-detail-row">
                <td colspan="11">
                  <table class="cs-detail-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Barkod</th>
                        <th>Sevk Tarihi</th>
                        <th class="cs-right">Masraf</th>
                        <th>Durum</th>
                        <th>Ödendi Tarihi</th>
                        <th>İşaretleyen</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(s, i) in row.shipments" :key="s.id">
                        <td>{{ i + 1 }}{{ s.retryIndex > 0 ? ' (R' + s.retryIndex + ')' : '' }}</td>
                        <td class="mono">{{ s.barcode }}</td>
                        <td>{{ formatDateTime(s.shippedAt) }}</td>
                        <td class="cs-right">{{ formatMoney(s.cost) }}</td>
                        <td>
                          <span :class="['cs-badge', s.isPaid ? 'cs-badge-paid' : 'cs-badge-unpaid']">
                            {{ s.isPaid ? '✓ Ödendi' : '✗ Ödenmedi' }}
                          </span>
                        </td>
                        <td>{{ s.isPaid ? formatDateTime(s.paidAt) : '—' }}</td>
                        <td>{{ s.paidBy || '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="total > pageSize" class="cs-pagination">
          <button class="cs-btn ghost" :disabled="page === 1" @click="load(page - 1)">◄ Önceki</button>
          <span>Sayfa {{ page }} / {{ Math.ceil(total / pageSize) }} (Toplam: {{ total }})</span>
          <button class="cs-btn ghost" :disabled="page * pageSize >= total" @click="load(page + 1)">Sonraki ►</button>
        </div>
      </section>

      <div v-if="selectedIds.length > 0" class="cs-action-bar">
        <div class="cs-action-info">
          <strong>{{ selectedIds.length }}</strong> sipariş seçildi
          <span class="cs-action-sep">·</span>
          Toplam: <strong>{{ formatMoney(selectedTotal) }}</strong>
          <span class="cs-action-sep">·</span>
          Ödenmemiş: <strong class="cs-unpaid-amount">{{ formatMoney(selectedUnpaid) }}</strong>
        </div>
        <div class="cs-action-buttons">
          <button class="cs-btn ghost" @click="clearSelection">İptal</button>
          <button class="cs-btn success" :disabled="markingPaid || selectedUnpaid === 0" @click="confirmMarkPaid">
            {{ markingPaid ? 'İşleniyor...' : '✓ Ödendi Olarak İşaretle' }}
          </button>
        </div>
      </div>

      <div v-if="confirmDialog.open" class="cs-modal-backdrop" @click.self="closeConfirm">
        <div class="cs-modal">
          <header class="cs-modal-head">
            <h3>Ödeme Onayı</h3>
            <button class="cs-btn ghost" :disabled="markingPaid" @click="closeConfirm">✕</button>
          </header>
          <div class="cs-modal-body">
            <p>{{ selectedIds.length }} siparişin tüm ödenmemiş kargo masrafları (toplam <strong>{{ formatMoney(selectedUnpaid) }}</strong>) <strong>Ödendi</strong> olarak işaretlenecek.</p>
            <p class="cs-modal-warn">Bu işlem geri alınamaz (şu anlık). Devam etmek istediğine emin misin?</p>
            <div class="cs-modal-actions">
              <button class="cs-btn ghost" :disabled="markingPaid" @click="closeConfirm">Vazgeç</button>
              <button class="cs-btn success" :disabled="markingPaid" @click="doMarkPaid">{{ markingPaid ? 'İşleniyor...' : 'Evet, İşaretle' }}</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import yurticiKargoApi from '@/api/yurticiKargo';

export default {
  name: 'CargoCostSettlement',
  data() {
    const now = new Date();
    const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    return {
      loading: false,
      markingPaid: false,
      page: 1,
      pageSize: 50,
      total: 0,
      items: [],
      summary: { totalCount: 0, totalAmount: 0, paidAmount: 0, unpaidAmount: 0 },
      expanded: {},
      selectedIds: [],
      filters: {
        from: this.isoDate(firstOfMonth),
        to: this.isoDate(now),
        paymentStatus: 'all',
      },
      confirmDialog: { open: false },
      selectedTenantId: parseInt(localStorage.getItem('selectedTenantId') || '0', 10),
      selectedMpId: parseInt(localStorage.getItem('selectedMpId') || '0', 10),
    };
  },
  computed: {
    isIdiaContext() {
      return this.selectedTenantId === 1 && this.selectedMpId === 5;
    },
    allChecked() {
      return this.items.length > 0 && this.selectedIds.length === this.items.length;
    },
    someChecked() {
      return this.selectedIds.length > 0 && this.selectedIds.length < this.items.length;
    },
    selectedRows() {
      const set = new Set(this.selectedIds);
      return this.items.filter((i) => set.has(i.orderId));
    },
    selectedTotal() {
      return this.selectedRows.reduce((sum, r) => sum + (r.totalCost || 0), 0);
    },
    selectedUnpaid() {
      return this.selectedRows.reduce((sum, r) => sum + (r.unpaidCost || 0), 0);
    },
  },
  mounted() {
    if (this.isIdiaContext) this.load(1);
  },
  methods: {
    isoDate(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    setThisMonth() {
      const now = new Date();
      const first = new Date(now.getFullYear(), now.getMonth(), 1);
      this.filters.from = this.isoDate(first);
      this.filters.to = this.isoDate(now);
      this.load(1);
    },
    async load(page) {
      if (!this.isIdiaContext) return;
      this.loading = true;
      this.page = page;
      try {
        const params = {
          from: this.filters.from,
          to: this.filters.to,
          paymentStatus: this.filters.paymentStatus,
          page,
          pageSize: this.pageSize,
        };
        const r = await yurticiKargoApi.cargoCostSettlement(params);
        const d = r.data || {};
        this.summary = d.summary || { totalCount: 0, totalAmount: 0, paidAmount: 0, unpaidAmount: 0 };
        this.items = d.items || [];
        this.total = d.total || 0;
        this.selectedIds = this.selectedIds.filter((id) => this.items.some((i) => i.orderId === id));
      } catch (e) {
        this.items = [];
        this.total = 0;
        this.summary = { totalCount: 0, totalAmount: 0, paidAmount: 0, unpaidAmount: 0 };
      } finally {
        this.loading = false;
      }
    },
    toggleAll(e) {
      if (e.target.checked) {
        this.selectedIds = this.items.map((i) => i.orderId);
      } else {
        this.selectedIds = [];
      }
    },
    toggleExpand(orderId) {
      this.$set(this.expanded, orderId, !this.expanded[orderId]);
    },
    clearSelection() {
      this.selectedIds = [];
    },
    confirmMarkPaid() {
      this.confirmDialog.open = true;
    },
    closeConfirm() {
      if (this.markingPaid) return;
      this.confirmDialog.open = false;
    },
    async doMarkPaid() {
      this.markingPaid = true;
      try {
        const ids = this.selectedIds.slice();
        const r = await yurticiKargoApi.markCargoCostPaid(ids);
        const d = r.data || {};
        if (d.success) {
          this.confirmDialog.open = false;
          this.selectedIds = [];
          await this.load(this.page);
          alert(`${d.affectedShipments} sevkiyat ödenmiş olarak işaretlendi.`);
        } else {
          alert('İşlem başarısız: ' + (d.error || 'bilinmeyen'));
        }
      } catch (e) {
        alert('İşlem hatası: ' + ((e.response && e.response.data && e.response.data.error) || e.message));
      } finally {
        this.markingPaid = false;
      }
    },
    formatMoney(v) {
      const n = Number(v) || 0;
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(n);
    },
    formatDate(v) {
      if (!v) return '—';
      return new Date(v).toLocaleDateString('tr-TR');
    },
    formatDateTime(v) {
      if (!v) return '—';
      const d = new Date(v);
      return d.toLocaleDateString('tr-TR') + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    },
    statusLabel(s) {
      if (s === 'paid') return '✓ Ödenmiş';
      if (s === 'partial') return '◐ Kısmen Ödenmiş';
      return '✗ Ödenmemiş';
    },
  },
};
</script>

<style scoped>
.cs-wrap { max-width: 1500px; margin: 24px auto; padding: 24px 24px 120px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; color: #1f2937; }
.cs-guard { background: #fef3c7; border-left: 4px solid #d4a017; padding: 16px 20px; border-radius: 6px; color: #78350f; }
.cs-guard p { margin: 8px 0 0 0; font-size: 13px; }
.cs-guard code { background: #fff; padding: 2px 6px; border-radius: 3px; font-size: 12px; }
.cs-header h1 { font-size: 22px; margin: 0 0 6px; color: #111; }
.cs-sub { font-size: 13px; color: #555; margin: 0 0 20px; }

.cs-filters { display: flex; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; align-items: end; background: #fff; padding: 14px; border: 1px solid #e5e7eb; border-radius: 8px; }
.cs-filter { display: flex; flex-direction: column; gap: 4px; }
.cs-filter label { font-size: 11px; color: #4b5563; font-weight: 500; }
.cs-filter input, .cs-filter select { padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; font-family: inherit; min-width: 160px; }
.cs-filter input:focus, .cs-filter select:focus { outline: none; border-color: #1d4ed8; }

.cs-btn { padding: 8px 14px; border: none; border-radius: 4px; font-size: 13px; cursor: pointer; font-weight: 500; font-family: inherit; }
.cs-btn.primary { background: #1d4ed8; color: white; }
.cs-btn.primary:hover { background: #1e40af; }
.cs-btn.primary:disabled { background: #9ca3af; cursor: not-allowed; }
.cs-btn.ghost { background: #fff; border: 1px solid #d1d5db; color: #374151; }
.cs-btn.ghost:hover { background: #f9fafb; }
.cs-btn.success { background: #16a34a; color: #fff; }
.cs-btn.success:hover:not(:disabled) { background: #15803d; }
.cs-btn.success:disabled { background: #9ca3af; cursor: not-allowed; }
.cs-btn-tiny { padding: 2px 8px; font-size: 11px; border-radius: 3px; margin-left: 8px; cursor: pointer; font-family: inherit; }
.cs-btn-tiny.ghost { background: #fff; border: 1px solid #d1d5db; color: #4b5563; }
.cs-btn-tiny.ghost:hover { background: #f3f4f6; }

.cs-summary { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 16px; }
.cs-card { background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px 18px; }
.cs-card-label { font-size: 12px; color: #6b7280; font-weight: 500; }
.cs-card-value { font-size: 22px; font-weight: 700; margin-top: 6px; }
.cs-card-sub { font-size: 12px; color: #9ca3af; margin-top: 4px; }
.cs-card-total { border-left: 4px solid #1d4ed8; }
.cs-card-paid { border-left: 4px solid #16a34a; }
.cs-card-paid .cs-card-value { color: #15803d; }
.cs-card-unpaid { border-left: 4px solid #dc2626; }
.cs-card-unpaid .cs-card-value { color: #b91c1c; }

.cs-table-wrap { background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; }
.cs-table { width: 100%; border-collapse: collapse; }
.cs-table th { background: #f9fafb; padding: 10px 12px; text-align: left; font-size: 12px; font-weight: 600; color: #4b5563; border-bottom: 1px solid #e5e7eb; }
.cs-table td { padding: 10px 12px; font-size: 13px; border-bottom: 1px solid #f3f4f6; }
.cs-table tr:hover { background: #f9fafb; }
.cs-row-expanded { background: #f5f9ff !important; }
.cs-col-check { width: 32px; text-align: center; }
.cs-col-check input { width: 16px; height: 16px; cursor: pointer; }
.cs-right { text-align: right; }
.cs-paid-amount { color: #15803d; font-weight: 600; }
.cs-unpaid-amount { color: #b91c1c; font-weight: 600; }
.cs-empty { text-align: center; color: #9ca3af; padding: 30px !important; }
.cs-shipment-count { display: inline-block; padding: 2px 8px; background: #e0e7ff; color: #3730a3; border-radius: 10px; font-size: 11px; font-weight: 600; }

.cs-badge { display: inline-block; padding: 2px 9px; border-radius: 10px; font-size: 11px; font-weight: 600; white-space: nowrap; }
.cs-badge-paid { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
.cs-badge-unpaid { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }
.cs-badge-partial { background: #fef3c7; color: #92400e; border: 1px solid #fde68a; }

.cs-detail-row { background: #fafbfc; }
.cs-detail-row > td { padding: 12px 24px !important; }
.cs-detail-table { width: 100%; border-collapse: collapse; background: #fff; border: 1px solid #e5e7eb; border-radius: 6px; overflow: hidden; }
.cs-detail-table th { background: #f3f4f6; padding: 8px 10px; font-size: 11px; font-weight: 600; color: #4b5563; text-align: left; border-bottom: 1px solid #e5e7eb; }
.cs-detail-table td { padding: 8px 10px; font-size: 12px; border-bottom: 1px solid #f3f4f6; }

.cs-pagination { display: flex; justify-content: space-between; align-items: center; padding: 12px 16px; border-top: 1px solid #e5e7eb; background: #f9fafb; font-size: 13px; color: #6b7280; }

.cs-action-bar { position: fixed; bottom: 0; left: 0; right: 0; background: #fff; border-top: 2px solid #16a34a; box-shadow: 0 -2px 12px rgba(0,0,0,0.08); padding: 14px 24px; display: flex; justify-content: space-between; align-items: center; z-index: 100; }
.cs-action-info { font-size: 14px; color: #1f2937; }
.cs-action-sep { color: #d1d5db; margin: 0 8px; }
.cs-action-buttons { display: flex; gap: 8px; }

.cs-modal-backdrop { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 200; display: flex; align-items: center; justify-content: center; }
.cs-modal { background: #fff; border-radius: 8px; max-width: 500px; width: 90%; overflow: hidden; }
.cs-modal-head { display: flex; justify-content: space-between; align-items: center; padding: 14px 18px; background: #f0fdf4; border-bottom: 1px solid #bbf7d0; }
.cs-modal-head h3 { margin: 0; font-size: 16px; color: #15803d; }
.cs-modal-body { padding: 18px; }
.cs-modal-body p { margin: 0 0 12px; font-size: 14px; color: #374151; }
.cs-modal-warn { font-size: 12px !important; color: #92400e !important; background: #fef3c7; padding: 8px 10px; border-radius: 4px; }
.cs-modal-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px; }

.mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12px; }
</style>
